<template lang="pug">
  div.d-flex.align-center
    div.d-flex.flex-column.align-center.mr-4(
      style="width: 80px;"
    )
      v-select(
        label="Lang"
        :items="languageOptions"
        :value="currentLanguage"
        solo
        dense
        item-text="name"
        item-value="value"
        hide-details
        @change="setCurrentLanguage"
      )
    v-menu(offset-y).text-center
        template(v-slot:activator="{ on }")
            v-btn(v-on="on" icon)
                v-icon mdi-dots-vertical

        v-list.user-menu
            v-list-item(@click="logout").user-menu__item
                v-list-item-title Logout
</template>

<script>
import errMixin from "@/mixins/errors.mixin"

const LANG_KEY = '_lang_';

export default {
  name: 'UserMenu',
  mixins: [errMixin],
  inject: ['logout'],
  data() {
    return {
      languageOptions: [{
        name: 'NL',
        value: 'nl'
      }, {
        name: 'EN',
        value: 'en'
      }],
      currentLanguage: 'nl',
    };
  },
  methods: {
    initLanguage() {
      const currentLang = localStorage.getItem(LANG_KEY);
      const supportedLangs = this.languageOptions.map(lang => lang.value);
      if (!supportedLangs.includes(currentLang)) {
        this.setCurrentLanguage('nl');
        return;
      }
      this.currentLanguage = currentLang || 'nl';
    },
    setCurrentLanguage(lang) {
      localStorage.setItem(LANG_KEY, lang);
      window.location.reload();
    }
  },
  mounted() {
    this.initLanguage();
  }
}
</script>

<style lang="scss">
.user-menu {
    &__item {
        cursor: pointer; 
        &:before {
            background-color: $bg-active-color;
            bottom: 0;
            content: "";
            left: 0;
            opacity: 0;
            pointer-events: none;
            position: absolute;
            right: 0;
            top: 0;
            transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
        }
        &:hover:before {
            opacity: .04;
        }
    }
}
</style>